<template>
  <div>
    <ul style="padding: 1em">
      <li v-for="item in data" :key="item._id" style="margin-bottom: 1rem">
        <fob-entity-compact
          :schema="schema"
          :data="item"
          :entityDetailsRoute="entityDetailsRoute"
          :entityEditRoute="entityEditRoute"
          :show-publication-type="showPublicationType"
          :show-star="showStar"
        >
        </fob-entity-compact>
      </li>
    </ul>
    <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
  </div>
</template>

<script>
import EntityCompact from '@/components/EntityCompact'

export default {
  name: 'fob-entity-list-compact',
  props: [
    'data',
    'entityDetailsRoute',
    'entityEditRoute',
    'schema',
    'showPublicationType',
    'showStar',
    'loading'
  ],
  components: {
    'fob-entity-compact': EntityCompact
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EntityListCompact.vue